import { PATH } from 'constants/RoutesConstants';

/**
 * @typedef {{
 *  name : string,
 *  defaultMessage: string,
 *  to: import('react-router').RouteProps
 *  'data-cy': string,
 * icon: string,
 * }} MenuItem
 *
 * @typedef {{
 *  name: string,
 *  defaultMessage: string,
 *  children: Array<MenuItem>
 * }} MenuItemGroup
 *
 * @type {Array<MenuItemGroup>}
 */
const navigationConfig = [
  {
    name: 'management',
    defaultMessage: 'Management',
    children: [
      {
        name: 'page.management.dashboard.group',
        defaultMessage: 'Group management',
        to: PATH.GROUP_MANAGEMENT,
        'data-cy': 'group_Management_Navigation_Btn',
        icon: 'management-group',
      },
      {
        name: 'page.management.dashboard.dealer',
        defaultMessage: 'Dealership management',
        to: PATH.DEALER_MANAGEMENT,
        'data-cy': 'management_Configuration_Navigation_Btn',
        icon: 'management-dealer',
      },

      {
        name: 'page.management.dashboard.personal',
        defaultMessage: 'Personal management',
        to: PATH.PERSONAL_CONFIG,
        'data-cy': 'personal_Configuration_Navigation_Btn',
        icon: 'management-user',
      },
    ],
  },
  {
    name: 'configuration',
    defaultMessage: 'Configuration',
    children: [
      {
        name: 'page.configuration.group',
        defaultMessage: 'Group configuration',
        to: PATH.GROUP_CONFIG_PAGE,
        'data-cy': 'group_Configuration_Navigation_Btn',
        icon: 'configuration',
      },
      {
        name: 'page.configuration.dealer',
        defaultMessage: 'Dealership configuration',
        to: PATH.DEALER_CONFIG_PAGE,
        'data-cy': 'general_Configuration_Navigation_Btn',
        icon: 'configuration',
      },
    ],
  },
  {
    name: 'administration',
    defaultMessage: 'Administration',
    children: [
      {
        name: 'administration',
        defaultMessage: 'Administration',
        to: PATH.DEALERS,
        'data-cy': 'dealers_Configuration_Navigation_Btn',
        icon: 'administration',
      },
      {
        name: 'page.releases.dashboard.title',
        defaultMessage: 'Release notes',
        to: PATH.RELEASES_DASHBOARD,
        'data-cy': 'releases_Configuration_Navigation_Btn',
        icon: 'file',
      }
    ],
  },
];

export default navigationConfig;
